export default __webpack_public_path__ + "static/media/iconeInlcuirProvedor.509584bc.png";